import {initializeSegment} from '../vue/utility/tracking/initializeSegment';

const xhr = new XMLHttpRequest();
xhr.addEventListener('load', () => {
  const environmentVars = JSON.parse(xhr.response);
  initializeSegment(environmentVars);
});
xhr.open('GET', '/api/?entity=open&action=getEnvironmentVars');
xhr.send();
